import {
  BaseTextFieldProps,
  FormControl,
  InputBaseProps,
  InputLabel,
  Typography,
} from "@material-ui/core"
import { Field, useField } from "formik"
import styled from "styled-components"
import FormikInput from "../../Reusable/Bit/Form/FormikInput"

const Styled = {
  Field: styled(Field)<{ $center?: boolean }>`
    width: 100%;
    .MuiFormHelperText-root {
      font-size: 20px;
    }
    .MuiFormHelperText-root.Mui-error {
      ${(p) => (p.$center ? `text-align: center;` : ``)};
    }
    input {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
  `,
  FormControl: styled(FormControl)``,
  FieldWrapper: styled.div<{ $topMargin?: string; $mobileTopMargin?: string }>`
    margin-top: ${(p) => (p.$topMargin ? `${p.$topMargin}px` : "28px")};
    input {
      font-family: Speedee, NarkisBlock, sans-serif;
      color: #000;
      font-size: 20px;
      font-weight: 500;
    }
    input[type="email"] {
      font-size: 16px;
      font-family: sans-serif, Speedee;
      font-weight: normal;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    .MuiOutlinedInput-root.Mui-error {
      fieldset {
        box-shadow: none;
        border: 1px solid #db0007;
        top: 0px;
        border-radius: 8px;
        height: 56px;
      }
    }
    .MuiOutlinedInput-root {
      border-radius: 8px;
      box-shadow: none;
    }
    .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
      border-radius: 8px;

      background: #fff;
    }
    .MuiFormLabel-root.Mui-error {
      color: #000;
      font-family: NarkisBlock;
    }

    // Added specifically for Giftcard Page
    ${(p) => p.theme.breakpoints.down("sm")} {
      ${(p) => p?.$mobileTopMargin && `margin-top: ${p.$mobileTopMargin}px;`}
      fieldset {
        min-height: 50px;
      }
    }
  `,
  LabelWrapper: styled.div`
    display: flex;
    align-items: center;
  `,
  InputLabel: styled(InputLabel)<{ $center?: boolean }>`
    transform: none !important;
    font-size: 18px;
    color: ${(p) => p.theme.colors.darkGrey};
    font-weight: 400;
    ${(p) =>
      p.$center ? `width: 100%; right: none; text-align: center;` : ``};
    line-height: 1.44;
    margin-top: 5px;
  `,
  BottomText: styled(Typography).attrs({ variant: "body1" })`
    text-align: start;
    font-size: 15px;
    margin-top: -23px;
    color: ${(p) => p.theme.colors.marbleGrey};
  `,
}

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label: string
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numeric?: boolean
  InputProps?: InputBaseProps
  bottomText?: string
  centerField?: boolean
  autoFocus?: boolean
  topMargin?: string
  mobileTopMargin?: string
  onChange?: any
  autoComplete?: string
}

const FormInput = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  maxLength,
  numeric,
  InputProps,
  centerField,
  autoFocus,
  topMargin,
  autoComplete,
  mobileTopMargin,
  ...props
}: CommonInputProps) => {
  const [field] = useField(name)
  return (
    <FormControl>
      {/* <Styled.InputLabel htmlFor={name} $center={centerField}>
        {label}
      </Styled.InputLabel> */}
      <Styled.FieldWrapper
        $topMargin={topMargin}
        $mobileTopMargin={mobileTopMargin}
      >
        <FormikInput
          name={name}
          type={type}
          required={required}
          placeholder={placeholder}
          maxLength={maxLength}
          numeric={numeric}
          centerField={centerField}
          InputProps={InputProps}
          autoFocus={autoFocus}
          label={label}
          autoComplete={autoComplete}
          {...field}
          {...props}
        />
      </Styled.FieldWrapper>

      {/* {bottomText && <Styled.BottomText>{bottomText}</Styled.BottomText>} */}
    </FormControl>
  )
}

export default FormInput
